var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskyFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6499 1.05029C14.0288 1.05029 14.4006 1.15278 14.726 1.3469C15.0514 1.54103 15.3182 1.81956 15.4982 2.15299L16.0086 3.09816C16.1886 3.43159 16.4554 3.71012 16.7808 3.90425C17.1062 4.09837 17.478 4.20086 17.8569 4.20086H19.9542C20.5112 4.20086 21.0455 4.42215 21.4394 4.81604C21.8332 5.20994 22.0545 5.74418 22.0545 6.30123V15.7529C22.0545 16.31 21.8332 16.8442 21.4394 17.2381C21.0455 17.632 20.5112 17.8533 19.9542 17.8533H3.15116C2.5941 17.8533 2.05986 17.632 1.66597 17.2381C1.27207 16.8442 1.05078 16.31 1.05078 15.7529V6.30123C1.05078 5.74418 1.27207 5.20994 1.66597 4.81604C2.05986 4.42215 2.5941 4.20086 3.15116 4.20086H5.24838C5.62689 4.20088 5.99837 4.09861 6.32354 3.90488C6.64872 3.71114 6.91549 3.43314 7.09566 3.10026L7.6092 2.15089C7.78937 1.81801 8.05615 1.54001 8.38132 1.34627C8.70649 1.15254 9.07797 1.05027 9.45648 1.05029H13.6499Z",
    stroke: "#374151",
    strokeWidth: 2.10038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5529 13.6522C13.2929 13.6522 14.7035 12.2416 14.7035 10.5016C14.7035 8.76163 13.2929 7.35107 11.5529 7.35107C9.8129 7.35107 8.40234 8.76163 8.40234 10.5016C8.40234 12.2416 9.8129 13.6522 11.5529 13.6522Z",
    stroke: "#374151",
    strokeWidth: 2.10038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskyFace);
export default __webpack_public_path__ + "static/media/riskyFace.114f4cd791cb9c219ecc4d5291998bbb.svg";
export { ForwardRef as ReactComponent };